<template>
  <div>
    <page-header
      class="scholarship-attendence__page-header"
      :page="pageHeaderConfig"
    >
      <div class="d-flex justify-content-end">
        <action-button
          i="fas fa-search"
          text="Ver Información de PEI"
          variant="outline-success scholarship-attendence__action-button"
          @click="goToPeiInformation()"
        />
        <action-button
          v-if="showApproveAssistance"
          i="fas fa-check"
          text="Aprobar Asistencia"
          variant="success ml-3"
          @click="onApproveAssistanceHandler()"
        />
      </div>
    </page-header>

    <filter-manager
      ref="attendanceFilterRef"
      v-model="filtersSelected"
      class="mb-4 scholarship-attendence__filter-manager"
      :filters="filterManagerConfig"
      @academicYear="onChangeAcademicYear"
      @search="onSearchHandler"
    >
      <template #header_advanced>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <drop-down
              :items="handlerFilters"
              :title="handlerFilters[handlerFilterSelected].label"
              variant="rounded-dark"
            />
          </div>
        </div>
      </template>
    </filter-manager>
    <div
      v-if="
        result.data.length > 0 &&
          (handlerFilterSelected == handlerFilterEnum.paymentManagement ||
            handlerFilterSelected == handlerFilterEnum.progress ||
            handlerFilterSelected == handlerFilterEnum.expiration)
      "
      class="row mt-4 m-0 mb-n4"
    >
      <div class="col d-flex justify-content-end align-items-center">
        <span class="mr-2 color-gray-7 font-weight-bold font-14">
          Seleccionar Todos
        </span>
        <check-box v-model="allSelected" class="w-auto" />
      </div>
    </div>

    <custom-separator class="pt-3 my-4" text="Resultado de Asistencias" />
    <result-not-found v-if="result.data.length === 0" />
    <div
      v-for="(item, index) in result.data"
      :key="`attendance-result-${index}`"
    >
      <validation-observer ref="sectionFormRef" novalidate tag="form">
        <callout
          :border-color="getColor(item.assistanceApprovalStatusCd)"
          class="mb-3 callout__extended"
          :controlled="true"
          :has-toggle="
            handlerFilterSelected == handlerFilterEnum.paymentManagement ||
              handlerFilterSelected == handlerFilterEnum.progress ||
              handlerFilterSelected == handlerFilterEnum.findings ||
              handlerFilterSelected == handlerFilterEnum.expiration
          "
          :opened="item.isOpen"
          @click:open="onOpenDetails(item, index)"
        >
          <row-standard
            v-if="
              handlerFilterSelected == handlerFilterEnum.paymentManagement ||
                handlerFilterSelected == handlerFilterEnum.progress ||
                handlerFilterSelected == handlerFilterEnum.expiration
            "
            :general-tab-index="item.mainTabModel"
            :index="index"
            :show-remaing-days="
              handlerFilterSelected == handlerFilterEnum.expiration
                ? true
                : false
            "
            :value="item"
            @additional-payment="onAdditionalPayment"
            @certification-document="onCertificationDocumentHandler"
            @denegate-assistance="onDenegateAssistanceHandler"
            @document-payroll="onDocumentPayrollHandler"
            @follow-up="onFollowUpAssitance"
            @manual-adjustment="onManualAdjustment"
            @on-select-tab-index="onSelectTabIndexHandler(index, item, $event)"
            @payment-relationship="onPaymentRelationship"
            @restart-payroll="restartPayrollHandler"
            @restart-status="restartStatusHandler"
          />
          <row-finding
            v-if="handlerFilterSelected == handlerFilterEnum.findings"
            :value="item"
            @on-set-finding-comment="onSetFindingCommentHandler(index)"
          />
          <template #edition>
            <div class="bg-gray p-2">
              <div class="bg-white rounded">
                <!-- Document Payroll -->
                <div
                  v-if="
                    item.openedSection == additionalSectionEnum.DOCUMENT_PAYROLL
                  "
                  class="mx-4 pt-3"
                >
                  <div class="row mb-3">
                    <div class="col">
                      <icon-view
                        icon="fa fa-file-invoice"
                        icon-background="#fff"
                        icon-color="#2DB782"
                        icon-size="16px"
                        title="Documentar Nómina"
                      />
                    </div>
                  </div>
                  <div class="row pb-3">
                    <div class="col-md-2">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-date-picker
                          v-model="model.payrollDate"
                          class="custom-date-picker"
                          custom-error-msg="Campo requerido."
                          :disabled="model.payrollDateReadonly"
                          :error="errors[0]"
                          label="Fecha de Nómina:"
                          :max-date="new Date()"
                          placeholder="DD/MM/YYYY"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-md-2">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-date-picker
                          v-model="model.receiveDate"
                          class="custom-date-picker"
                          custom-error-msg="Campo requerido."
                          :disabled="model.receivedDateReadonly"
                          :error="errors[0]"
                          label="Fecha de Recibido:"
                          :max-date="new Date()"
                          placeholder="DD/MM/YYYY"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-md-2">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-drop-down
                          v-model="model.receive"
                          custom-error-msg="Campo requerido."
                          :error="errors[0]"
                          fieldkey="id"
                          fieldname="name"
                          label="Recibido:"
                          :options="filterPayRoll"
                          placeholder="Seleccione"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-md-2">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-input
                          v-model="model.assistance"
                          custom-error-msg="Campo requerido."
                          :error="errors[0]"
                          label="Asistencia:"
                          type="number"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-md-4 pt-4 doc-payroll-action">
                      <action-button
                        i="fas fa-times-circle"
                        variant="outline-danger btn-cancel danger m-2 pl-4 pr-4 scholarship-attendence__action-button"
                        @click="onCancelDocPayrollHandler(index)"
                      >
                        Cancelar
                      </action-button>
                      <action-button
                        i="fas fa-check"
                        variant="success pl-4 pr-4 scholarship-attendence__action-button"
                        @click="onConfirmHandler(index)"
                      >
                        Confirmar
                      </action-button>
                    </div>
                  </div>
                </div>

                <!-- Denegate Assistance -->
                <div
                  v-if="
                    item.openedSection ==
                      additionalSectionEnum.DENEGATE_ASSISTANCE
                  "
                >
                  <additional-section
                    :assistance-summaries-related="
                      model.assistanceSummariesRelated
                    "
                    :assistance-summary-id="item.assistanceSummaryId"
                    chk-title="Denegar Pagos Adicionales"
                    dd-title="Razón de Denegación:"
                    icon="fas fa-times-circle"
                    icon-background="#d7383f"
                    icon-color="#fff"
                    :index="index"
                    message-error="Favor seleccionar uno o varios periodos para completar el proceso de Denegar pagos adicionales."
                    :options="model.complianceReasons"
                    section-title="Denegar Asistencia"
                    :show-status-indicator="true"
                    @on-cancel="onCancelDenegateHandler(index)"
                    @on-confirm="onSaveDenegateHandler"
                  />
                </div>

                <!-- Additional Payment -->
                <additional-payment
                  v-if="
                    item.openedSection ==
                      additionalSectionEnum.ADDITIONAL_PAYMENT
                  "
                  @on-cancel="onCancelAdditionalPayment(index)"
                  @on-confirm="onConfirmAdditionalPayment(index, $event)"
                />

                <!-- Manual Adjustment -->
                <manual-adjustment
                  v-if="
                    item.openedSection ==
                      additionalSectionEnum.MANUAL_ADJUSTMENT
                  "
                  :assistance-summary-id="item.assistanceSummaryId"
                  :cost-total-amount="item.costTotalAmt || 0"
                  :has-manual-adjustment="item.manualAdjustmentAmt"
                  :index="index"
                  :manual-amount="item.manualAdjustmentAmt || 0"
                  :reason-comment="item.manualAdjustmentDescription"
                  :reason-selected="
                    item.manualAdjustmentReasonCd != null
                      ? {
                          id: item.manualAdjustmentReasonCd,
                          name: item.manualAdjustmentReasonName,
                        }
                      : null
                  "
                  :reasons="model.adjustmentReasons"
                  :total-attended-amount="item.totalAttendedAmt || 0"
                  @on-cancel="onCancelManualAdjustment(index)"
                  @on-confirm="onSaveManualAdjustment"
                  @on-delete="onDeleteManualAdjustment"
                />

                <!-- Relación de Pago -->
                <payment-relationship
                  v-if="
                    item.openedSection ==
                      additionalSectionEnum.PAYMENT_RELATIONSHIP
                  "
                  :assistance-summary-id="item.assistanceSummaryId"
                  :student-sie-id="item.studentSieId"
                  @on-cancel="onCancelPaymentRelatinship(index)"
                  @on-refresh="onRefreshPaymentRelationshipHandler"
                />

                <!-- Comentario -->
                <div
                  v-if="item.openedSection == additionalSectionEnum.FOLLOW_UP"
                >
                  <additional-section
                    :assistance-summaries-related="
                      model.assistanceSummariesRelated
                    "
                    :assistance-summary-id="item.assistanceSummaryId"
                    chk-title="Documentar Comentarios Adicionales"
                    dd-title="Categoría"
                    icon="fas fa-comment"
                    icon-background="#fff"
                    icon-color="#2DB782"
                    :index="index"
                    message-error="Favor seleccionar uno o varios periodos para completar el proceso de Documentar comentarios adicionales."
                    :options="model.followUpCategories"
                    section-title="Comentario"
                    @on-cancel="onCancelFollowUp(index)"
                    @on-confirm="onSaveFollowUp"
                  />
                </div>

                <!-- Tabs -->
                <div v-if="item.openedSection == additionalSectionEnum.TABS">
                  <custom-tab
                    v-model="item.mainTabModel"
                    content-class="mt-3"
                    nav-class="custom-nav-container"
                    :no-nav-style="true"
                    @input="onActiveTab(item, $event)"
                  >
                    <custom-tab-item active lazy title="Información Adicional">
                      <additional-info
                        :is-thrpy-service="
                          (isTherapyService(item.peiAnalysisServiceId) &&
                            thrpyInfo) ||
                            handlerFilterSelected !== handlerFilterEnum.findings
                        "
                        :thrpy-info="thrpyInfo || {}"
                        :transportation-info="transportationInfo || {}"
                        :value="item"
                      />
                    </custom-tab-item>
                    <custom-tab-item
                      v-if="canShowTab"
                      :active="
                        mainTabsEnum.ASSISTANCE_DETAILS === item.mainTabModel
                      "
                      lazy
                      title="Detalles de Asistencia"
                      @click="onSelectTabAssistanceDetails(index, item)"
                    >
                      <assistance-details
                        :adjust-assistances="item.adjustAssistances"
                        :adjust-periods="item.adjustPeriods"
                        :assistance-service="item.assistanceService"
                        :assistance-summary="item"
                        :normal-assistances="item.normalAssistances"
                        :selected-period="item.selectedPeriod"
                        :show-assistance-service="showAssistanceService(item)"
                        @on-select-adjusment-period="
                          onSelectAdjustmentPeriodHandler(index, item, $event)
                        "
                        @on-update-milleage-companion="
                          onUpdateMillageCompanion(index, item)
                        "
                      />
                      <assistance-visit
                        v-if="showAssistanceVisit(item.payrollReceiveTypeId)"
                        :rows="item.assistanceVisitResult"
                      />
                    </custom-tab-item>
                    <custom-tab-item
                      v-if="canShowTab"
                      :active="mainTabsEnum.PAYMENTS === item.mainTabModel"
                      lazy
                      title="Pagos"
                      @click="onSelectTabPayment(index, item)"
                    >
                      <payment
                        :additional-payments="item.additionalPayments || []"
                        :payment-relationship="relationshipPayment"
                        :status="item.assistanceApprovalStatusCd"
                        :value="item.payment || {}"
                        @on-delete="onDeleteAdditionalPaymentHandler"
                        @on-delete-relation="
                          onDeleteRelationHandler(item, $event)
                        "
                      />
                    </custom-tab-item>
                    <custom-tab-item
                      :active="mainTabsEnum.HISTORY === item.mainTabModel"
                      lazy
                      title="Historial"
                      @click="onSelectHistoryTab(index, item)"
                    >
                      <history
                        v-if="item.showHistory"
                        :id="
                          isFinding
                            ? item.eligibleStudentId
                            : item.assistanceSummaryId
                        "
                        :default-category="
                          isFinding ? assistanceEventTypeEnum.Hallazgo : null
                        "
                        :hide-filter="isFinding"
                      />
                    </custom-tab-item>
                    <custom-tab-item
                      v-if="item.hasCompliance && canShowTab"
                      lazy
                      title="Informe de Progreso"
                      @click="onSelectTabProgressReport(index, item)"
                    >
                      <progress-inform :value="item.progressReport || {}" />
                    </custom-tab-item>
                  </custom-tab>
                </div>

                <!-- Comentario Hallazgo -->
                <div
                  v-if="
                    item.openedSection == additionalSectionEnum.FINDING_COMMENT
                  "
                >
                  <finding-comment
                    @on-cancel="onCancelFindingCommentHandler(index, item)"
                    @on-confirm="
                      onSaveFindingCommentHandler(index, item, $event)
                    "
                  />
                </div>
              </div>
            </div>
          </template>
        </callout>
        <div v-if="item.sieSiblings && item.sieSiblings.length > 0">
          <error
            icon="fa-info-circle"
            is-alert-mode
            :message="
              `Este estudiante tiene hermanos que actualmente cuentan con BECA: ${item.sieSiblings}`
            "
            style="background: #FFEDBB; border: none; color: #AF7304 !important;position: relative; bottom: 17px;"
          />
        </div>
        <div v-if="false" class="bg-secondary-19 p-2 rounded mt-n3 mb-3">
          <span class="color-secondary-20 font-14 font-weight-normal">
            <p class="fas fa-bell-exclamation icon">
              Los records Educativos Públicos deben estar marcados analizados
              para poder aprobar los pagos.
            </p>
          </span>
        </div>
        <div
          v-if="item.isNotEligible"
          class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
        >
          <div
            class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
          >
            <em class="fas fa-bell-exclamation pl-1" />
            <div class="ml-2 no-eligible-message pl-2">
              El estudiante no es elegible para Becas de Transportación de
              acuerdo a los PEI’s firmados en el sistema.
            </div>
          </div>
        </div>
        <div
          v-if="item.invalidTotalAmount"
          class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
        >
          <div
            class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
          >
            <em class="fas fa-bell-exclamation pl-1 color-secondary-20" />
            <div class="ml-2 no-eligible-message pl-2 color-secondary-20">
              El record de pago no cuenta con un total valido para ser aprobado.
            </div>
          </div>
        </div>
        <div
          v-if="item.invalidApprovePayment"
          class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
        >
          <div
            class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
          >
            <em class="fas fa-bell-exclamation pl-1 color-secondary-20" />
            <div class="ml-2 no-eligible-message pl-2 color-secondary-20">
              Los records Educativos Públicos deben estar marcados analizados
              para poder aprobar los pagos.
            </div>
          </div>
        </div>
      </validation-observer>
      <div
        v-if="item.eligibleFlag"
        class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
      >
        <em class="fa fa-bell-exclamation color-secondary-21 mr-2" />
        <span class="color-secondary-21 font-14 font-weight-normal">
          {{ item.eligibleFlagDescription }}
        </span>
      </div>
      <div v-if="item.errorFlag" class="bg-secondary-19 p-2 rounded mt-n3 mb-3">
        <em class="fa fa-times-circle color-secondary-20 mr-2" />
        <span class="color-secondary-20 font-14 font-weight-normal">
          {{ item.errorDescription }}
        </span>
      </div>
      <div
        v-if="item.notEligibleStudent"
        class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
      >
        <div
          class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
        >
          <em class="fa fa-times-circle color-secondary-20 mr-2" />
          <div class="color-secondary-20 font-14 font-weight-normal">
            No es posible aprobar la(s) asitencia(s), ya que cuenta con
            estudiante(s) no elegible(s) para Becas de Transportación de acuerdo
            a los PEI’s firmados en el sistema.
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPagination" class="row">
      <div class="col-1 pt-3">
        <custom-drop-down
          v-model="selectedPaging"
          :clearable="false"
          fieldkey="id"
          fieldname="name"
          :options="pagingList"
          @input="onSelectedPagingHandler"
        />
      </div>
      <div class="col-11">
        <pagination
          :data="result"
          :page-size="pageSize"
          :show-text="true"
          @pagination-go-page="goToPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import ResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import IconView from 'icon-view';
import Callout from 'custom-callout';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import Error from '@/components/common/Error';
import {
  RowFinding,
  RowStandard,
  AdditionalPayment,
  ManualAdjustment,
  PaymentRelationship,
  AdditionalSection,
  FindingComment,
} from './components';
import {
  AdditionalInfo,
  ProgressInform,
  AssistanceDetails,
  Payment,
  History,
  AssistanceVisit,
} from './components/tabs';
import { Colors } from '@/components/common';
import {
  searchScholarship as _searchScholarship,
  getAdvanceFilters as _getAdvanceFilters,
  approveAttendance as _approveAttendance,
  searchFindings as _searchFindings,
  searchScholarshipProgress as _searchScholarshipProgress,
  getAssistanceDetailInfo as _getAssistanceDetailInfo,
  getPaymentDetail as _getPaymentDetail,
  getProgressReport as _getProgressReport,
  updateAssistanceSummary as _updateAssistanceSummary,
  getAssistanceDetailPeriods as _getAssistanceDetailPeriods,
  denyassistance as _denyassistance,
  compliancereasons as _compliancereasons,
  manualAdjustmentAssistance as _manualAdjustmentAssistance,
  additionalPayment as _additionalPayment,
  saveFollowUpAssistance as _saveFollowUpAssistance,
  getAssistanceTherapyInfo as _getAssistanceTherapyInfo,
  getAssistanceTransportationInfo as _getAssistanceTransportationInfo,
  resetPaymentStatus as _resetPaymentStatus,
  getBillingAssistance as _getBillingAssistance,
  getAssistanceSummaries as _getAssistanceSummaries,
  getAssistanceSummariesForDenyPayments as _getAssistanceSummariesForDenyPayments,
  getAdditionalPaymentList as _getAdditionalPaymentList,
  removeManualAdjustment as _removeManualAdjustment,
  getPaymentRelationship as _getPaymentRelationship,
  getCertificationDocument as _getCertificationDocument,
  checkPaymentStatus as _checkPaymentStatus,
  deleteRecordFromPaymentJournal as _deleteRecordFromPaymentJournal,
  getAssistanceDetailService as _getAssistanceDetailService,
  deleteAdditionalPayment as _deleteAdditionalPayment,
  removeServiceRelation as _removeServiceRelation,
  saveFindingComment as _saveFindingComment,
  resetPayroll as _resetPayroll,
  updateMillageCompanion as _updateMillageCompanion,
} from '@/modules/shared/scholarship.api.js';

import {
  getAcademicYearsWithLoadProcess as _getAcademicYearsWithLoadProcess,
  getPeriodsWithLoadProcess as _getPeriodsWithLoadProcess,
} from '@/modules/shared/academicyear.api.js';
import {
  getDisciplineTypesSplit as _getDisciplineTypesSplit,
  getPayrollReceiveTypeAsync as _getPayrollReceiveTypeAsync,
  getAdjustmentReasons as _getAdjustmentReasons,
  getFollowUpCategories as _getFollowUpCategories,
} from '@/modules/shared/code.api.js';
import alertMixin from 'utils/mixins/alert.mixin.js';
import serviceTypeEnum from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';
import payrollReceiveTypes from '@/utils/constants/payrollReceiveTypes.js';
import { getUser } from '@/core/auth';
import storeMixin from 'utils/mixins/storeGenerator';
import _generalApi from '@/modules/app/api';
import assistanceEventType from '@/utils/constants/assistanceEventTypes.js';
import { getSchools as _getSchools } from '@/modules/shared/location.api';

const statusEnum = Object.freeze({
  pending: 1,
  approved: 2,
  denegate: 3,
  review: 5,
  no_payment: 6,
  payment: 7,
});

const OPENED_SECTION_KEY = 'openedSection';
const STORE_MODULE_NAME = 'AttendanceModule';
const DEFAULT_PAGE_SIZE = 15;
const PEI_INFORMATION_ROUTE_NAME = 'PeiInformation';

export default {
  name: 'Attendance',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    ResultNotFound,
    Pagination,
    RowStandard,
    RowFinding,
    AdditionalInfo,
    ProgressInform,
    AssistanceDetails,
    Payment,
    History,
    IconView,
    CustomDatePicker,
    CustomDropDown,
    CustomInput,
    ActionButton,
    Callout,
    AdditionalPayment,
    ManualAdjustment,
    PaymentRelationship,
    AssistanceVisit,
    AdditionalSection,
    CustomTab,
    CustomTabItem,
    FindingComment,
    Error,
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    relationshipPayment: {
      services: null,
    },
    moduleName: STORE_MODULE_NAME,
    allSelected: false,
    selected: [],
    hideDropDown: false,
    filtersSelected: {
      academicYear: null,
      present: null,
    },
    handlerFilterSelected: 0,
    handlerFilterEnum: {
      paymentManagement: 0,
      findings: 1,
      progress: 2,
      expiration: 3,
    },
    compliancesEnum: {
      no: 0,
      si: 1,
    },
    presentsEnum: {
      eligible: 1,
      notEligible: 2,
    },
    filter: {
      academicYearId: null,
    },
    filterPayRoll: [],
    catalog: {
      academicYears: [],
      services: [],
    },
    result: {
      data: [],
    },
    complianceReasons: [],
    selectedComplianceReason: null,
    pageSize: 15,
    page: 1,
    model: {
      complianceReasons: [],
      selectedComplianceReason: null,
      assistanceDenialDescription: null,
      adjustmentReasons: [],
      followUpCategories: [],
      assistanceSummariesRelated: null,
    },
    advanceFilters: {
      assistanceApprovalStatus: [],
      regions: [],
      reasons: [],
      analyzing: [],
      complianceReasons: [],
      compliances: [],
      presents: [],
      schools: [],
      expirations: [],
    },
    assistanceSummariesToApprove: [],
    thrpyInfo: null,
    transportationInfo: null,
    assistanceVisitResult: [],
    mainTabModel: 0,
    selectedPaging: null,
  }),
  computed: {
    pageHeaderConfig() {
      return {
        title: 'Manejo de Pago Estudiantes Elegibles',
        icon: 'fas fa-user-tie',
        routes: [
          'Inicio',
          'Becas',
          'Manejo de Pago Estudiantes Becas de Transportación',
          'Manejo de Pago Estudiantes Elegibles',
        ],
      };
    },
    filterManagerConfig() {
      return this.switchResult(this.handlerFilterSelected);
    },
    getColor() {
      return (status) => {
        switch (status) {
          case statusEnum.payment:
            return 'primary-15';
          case statusEnum.approved:
            return 'secondary-36';
          case statusEnum.pending:
          case statusEnum.no_payment:
            return Colors.YELLOW;
          case statusEnum.denegate:
            return Colors.BROWN;
          case statusEnum.review:
            return 'secondary-16';
          default:
            return 'secondary-19';
        }
      };
    },
    actionItems() {
      return [
        {
          name: 'approve',
          label: 'Aprobar',
          icon: 'fas fa-check-square color-primary-1',
          click: () => {},
        },
        {
          name: 'denegate',
          label: 'Denegar',
          icon: 'fas fa-times-square color-primary-1',
          click: () => {},
        },
        {
          name: 'manual adjustment',
          label: 'Ajuste Manual',
          icon: 'fas fa-edit color-primary-1',
          click: () => {},
        },
        {
          name: 'payment',
          label: 'Relacionar pago',
          icon: 'fas fa-usd-square color-primary-1',
          click: () => {},
        },
      ];
    },
    showPagination() {
      return (
        this.result.data.length > 0 &&
        this.result.totalItemCount > this.pageSize
      );
    },
    handlerFilters() {
      const {
        paymentManagement,
        findings,
        progress,
        expiration,
      } = this.handlerFilterEnum;
      return [
        {
          label: 'Manejo de Pago',
          click: () => (
            this.cleanData(), (this.handlerFilterSelected = paymentManagement)
          ),
        },
        {
          label: 'Hallazgos',
          click: () => (
            this.cleanData(), (this.handlerFilterSelected = findings)
          ),
        },
        {
          label: 'Informe de Progreso',
          click: () => (
            this.cleanData(), (this.handlerFilterSelected = progress)
          ),
        },
        {
          label: 'Vencimiento de Término',
          click: () => (
            this.cleanData(), (this.handlerFilterSelected = expiration)
          ),
        },
      ];
    },
    additionalSectionEnum() {
      return {
        TABS: 'tabSection',
        DOCUMENT_PAYROLL: 'documentPayrollSection',
        DENEGATE_ASSISTANCE: 'denegateAssistanceSection',
        ADDITIONAL_PAYMENT: 'additionalPaymentSection',
        MANUAL_ADJUSTMENT: 'manualAdjustmentSection',
        PAYMENT_RELATIONSHIP: 'paymentRelationshipSection',
        FOLLOW_UP: 'followUpSection',
        FINDING_COMMENT: 'findingComment',
      };
    },
    showApproveAssistance() {
      return this.result.data.some((x) => x.isChecked);
    },
    isTherapyService() {
      return (serviceId) =>
        [
          serviceTypeEnum.terapiaDeHabla,
          serviceTypeEnum.terapiaOcupacional,
          serviceTypeEnum.terapidaPsicologica,
          serviceTypeEnum.terapiaFisica,
          serviceTypeEnum.terapiaOromotora,
        ].includes(serviceId);
    },
    showAssistanceVisit() {
      return (id) =>
        id == payrollReceiveTypes.FacturacionEnLineaSAEE ||
        id == payrollReceiveTypes.FacturacionEnLineaRP;
    },
    showAssistanceService() {
      return (item) =>
        [
          serviceTypeEnum.educativo,
          serviceTypeEnum.terapiaDeHabla,
          serviceTypeEnum.terapiaOcupacional,
          serviceTypeEnum.terapidaPsicologica,
          serviceTypeEnum.terapiaFisica,
          serviceTypeEnum.terapiaOromotora,
          serviceTypeEnum.terapiaDisfagia,
          serviceTypeEnum.otros,
        ].includes(item.peiAnalysisServiceId) && item.isManualAssistanceFlag;
    },
    canShowTab() {
      return this.handlerFilterSelected != this.handlerFilterEnum.findings;
    },
    isFinding() {
      return this.handlerFilterSelected === this.handlerFilterEnum.findings;
    },
    assistanceEventTypeEnum() {
      return assistanceEventType;
    },
    mainTabsEnum() {
      return {
        ADDITIONAL_INFO: 0,
        ASSISTANCE_DETAILS: 1,
        PAYMENTS: 2,
        HISTORY: 3,
      };
    },
    pagingList() {
      return [
        {
          id: 15,
          name: 15,
        },
        {
          id: 20,
          name: 20,
        },
        {
          id: 25,
          name: 25,
        },
        {
          id: 30,
          name: 30,
        },
      ];
    },
  },
  watch: {
    allSelected(value) {
      this.result.data.forEach((item) => {
        item.isChecked = value;
      });
    },
    'filtersSelected.academicYear'(newVal, oldVal) {
      if (!oldVal) {
        this.callGetPeriods(newVal.id);
      }
    },
  },
  mounted() {
    this.callGetInitFilters();
    this.callAdvanceFilters();
    this.InitPayrollFilter();

    //set default paging
    if (!this.selectedPaging) {
      this.selectedPaging = this.pagingList.find((x) => x.id == this.pageSize);
    }
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case statusEnum.pending:
          return true;
        case statusEnum.denegate:
          return true;
        case statusEnum.review:
          return true;
        default:
          return false;
      }
    },
    cleanData() {
      this.result = { data: [] };
      this.page = 1;
    },
    async onRegionChanged() {
      if (this.filtersSelected.region == null) {
        _getSchools({
          academicYearId: this.filtersSelected.academicYear.id,
          regionId: null,
        }).then(({ data }) => {
          this.advanceFilters.schools = data;
          this.filtersSelected.school = null;
        });
        return;
      }
      this.filtersSelected.academicYear;
      _getSchools({
        academicYearId: this.filtersSelected.academicYear.id,
        regionId: this.filtersSelected.region?.id,
      }).then(({ data }) => {
        this.advanceFilters.schools = data;
        this.filtersSelected.school = null;
      });
    },
    switchResult(option) {
      switch (option) {
        case 0:
          return [
            {
              component: 'CustomDropDown',
              name: 'academicYear',
              options: this.catalog.academicYears,
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              clearable: false,
              immediateOnChanged: false,
            },
            {
              component: 'CustomDropDown',
              name: 'period',
              options: this.catalog.periods,
              placeholder: 'Seleccione Periodo',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomDropDown',
              name: 'service',
              options: this.catalog.services,
              placeholder: 'Seleccione Servicio',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomInput',
              name: 'ssnosie',
              placeholder: 'Escribe SSN, SIE o Registro',
              class: 'col-md-3',
              icon: 'fa fa-search color-orange',
              leftIcon: true,
              maskType: 'SieOrSSNorRegistryNumber',
              searchable: true,
            },
            {
              component: 'CustomDropDown',
              name: 'region',
              label: 'Región:',
              options: this.advanceFilters.regions,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
              onChanged: this.onRegionChanged,
            },
            {
              component: 'CustomDropDown',
              name: 'school',
              label: 'Escuela:',
              options: this.advanceFilters.schools,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'status',
              label: 'Estatus:',
              options: this.advanceFilters.assistanceApprovalStatus,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'analyzing',
              label: 'Analizado:',
              options: this.advanceFilters.analyzing,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'working',
              label: 'Trabajado:',
              options: this.advanceFilters.workings,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'present',
              label: 'Presentar:',
              options: this.advanceFilters.presents,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'receiveType',
              label: 'Medio de Recibo:',
              options: this.advanceFilters.receiveTypes,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
          ];
        case 1:
          return [
            {
              component: 'CustomDropDown',
              name: 'academicYear',
              options: this.catalog.academicYears,
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              clearable: false,
            },
            {
              component: 'CustomDropDown',
              name: 'period',
              options: this.catalog.periods,
              placeholder: 'Seleccione Periodo',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomDropDown',
              name: 'service',
              options: this.catalog.services,
              placeholder: 'Seleccione Servicio',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomInput',
              name: 'ssnosie',
              placeholder: 'Escribe SSN o SIE',
              class: 'col-md-3',
              icon: 'fa fa-search color-orange',
              leftIcon: true,
              type: 'Number',
              searchable: true,
            },
            {
              component: 'CustomDropDown',
              name: 'region',
              label: 'Región:',
              options: this.advanceFilters.regions,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'reason',
              label: 'Tipo de Hallazgo:',
              options: this.advanceFilters.reasons,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
          ];
        case 2:
          return [
            {
              component: 'CustomDropDown',
              name: 'academicYear',
              options: this.catalog.academicYears,
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              clearable: false,
            },
            {
              component: 'CustomDropDown',
              name: 'period',
              options: this.catalog.periods,
              placeholder: 'Seleccione Periodo',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomDropDown',
              name: 'service',
              options: this.catalog.services,
              placeholder: 'Seleccione Servicio',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomInput',
              name: 'ssnosie',
              placeholder: 'Escribe SSN o SIE',
              class: 'col-md-3',
              icon: 'fa fa-search color-orange',
              leftIcon: true,
              type: 'Number',
              searchable: true,
            },
            {
              component: 'CustomDropDown',
              name: 'region',
              label: 'Región:',
              options: this.advanceFilters.regions,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'compliances',
              label: 'Completado:',
              options: this.advanceFilters.compliances,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
              onChanged: this.onChangeCompliances,
            },
            {
              component: 'CustomDropDown',
              name: 'compliancereasons',
              label: 'Razón de Completado:',
              options: this.advanceFilters.complianceReasons,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
              visible: this.hideDropDown,
            },
          ];
        case 3:
          return [
            {
              component: 'CustomDropDown',
              name: 'academicYear',
              options: this.catalog.academicYears,
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              clearable: false,
            },
            {
              component: 'CustomDropDown',
              name: 'period',
              options: this.catalog.periods,
              placeholder: 'Seleccione Periodo',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomDropDown',
              name: 'service',
              options: this.catalog.services,
              placeholder: 'Seleccione Servicio',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
            },
            {
              component: 'CustomInput',
              name: 'ssnosie',
              placeholder: 'Escribe SSN o SIE',
              class: 'col-md-3',
              icon: 'fa fa-search color-orange',
              leftIcon: true,
              type: 'Number',
              searchable: true,
            },
            {
              component: 'CustomDropDown',
              name: 'region',
              label: 'Región:',
              options: this.advanceFilters.regions,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
            {
              component: 'CustomDropDown',
              name: 'expiration',
              label: 'Vencimiento:',
              options: this.advanceFilters.expirations,
              placeholder: 'Seleccione',
              fieldKey: 'id',
              fieldName: 'name',
              class: 'col-md-3',
              isAdvanced: true,
            },
          ];

        default:
      }
    },
    async callGetInitFilters() {
      const { data } = await _getAcademicYearsWithLoadProcess();
      this.catalog = {
        ...this.catalog,
        academicYears: data,
      };

      this.filtersSelected = {
        ...this.filtersSelected,
        academicYear: this.filtersSelected.academicYear
          ? this.filtersSelected.academicYear
          : data[0],
      };

      this.callGetServices();

      _getSchools({
        academicYearId: this.filtersSelected.academicYear.id,
      }).then(({ data }) => {
        this.advanceFilters.schools = data;
        this.filtersSelected.school = null;
      });
    },
    async callGetPeriods(academicYearId) {
      const { data } = await _getPeriodsWithLoadProcess(academicYearId);
      this.catalog = {
        ...this.catalog,
        periods: data,
      };
    },
    async callGetServices() {
      const { data } = await _getDisciplineTypesSplit();
      this.catalog = {
        ...this.catalog,
        services: data.concat(data.splice(data.length - 2, 1)),
      };
    },
    async callSearchScholarship() {
      if (this.handlerFilterSelected == this.handlerFilterEnum.findings) {
        const payload = {
          academicYearId: this.filtersSelected.academicYear?.id ?? null,
          monthNumber: this.filtersSelected.period?.id ?? null,
          disciplineTypeId: this.filtersSelected.service?.id ?? null,
          regionId: this.filtersSelected.region?.id ?? null,
          reasonId: this.filtersSelected.reason?.id ?? null,
          socialSecurityNumber:
            this.filtersSelected.ssnosie?.length == 9
              ? this.filtersSelected.ssnosie
              : null,
          studentSieId:
            this.filtersSelected.ssnosie?.length <= 8
              ? this.filtersSelected.ssnosie
              : null,
          regStudentId:
            this.filtersSelected.ssnosie?.length >= 9
              ? this.filtersSelected.ssnosie
              : null,
          pageIndex: this.page,
          pageSize: this.pageSize,
        };
        const { data } = await _searchFindings(payload);
        this.result = data;
      } else if (
        this.handlerFilterSelected == this.handlerFilterEnum.paymentManagement
      ) {
        const payload = {
          academicYearId: this.filtersSelected.academicYear?.id ?? null,
          monthNumber: this.filtersSelected.period?.id ?? null,
          disciplineTypeId: this.filtersSelected.service?.id ?? null,
          regionId: this.filtersSelected.region?.id ?? null,
          schoolId: this.filtersSelected.school?.id ?? null,
          statusId: this.filtersSelected.status?.id ?? null,
          socialSecurityNumber:
            this.filtersSelected.ssnosie?.length == 9
              ? this.filtersSelected.ssnosie
              : null,
          studentSieId:
            this.filtersSelected.ssnosie?.length <= 8
              ? this.filtersSelected.ssnosie
              : null,
          regStudentId:
            this.filtersSelected.ssnosie?.length >= 10
              ? this.filtersSelected.ssnosie
              : null,
          isWorked: this.filtersSelected.working?.id
            ? this.filtersSelected.working.id == 1
              ? true
              : false
            : null,
          isPrivate: this.filtersSelected.analyzing?.id
            ? this.filtersSelected.analyzing?.id == 1
              ? true
              : false
            : null,
          isNotEligible: this.filtersSelected.present?.id
            ? this.filtersSelected.present?.id == this.presentsEnum.notEligible
              ? true
              : false
            : null,
          receiveTypeId: this.filtersSelected?.receiveType?.id ?? null,
          pageIndex: this.page,
          pageSize: this.pageSize,
        };
        const { data } = await _searchScholarship(payload);
        this.result = data;
      } else if (
        this.handlerFilterSelected == this.handlerFilterEnum.progress
      ) {
        const payload = {
          academicYearId: this.filtersSelected.academicYear?.id ?? null,
          monthNumber: this.filtersSelected.period?.id ?? null,
          disciplineTypeId: this.filtersSelected.service?.id ?? null,
          regionId: this.filtersSelected.region?.id ?? null,
          reasonComplianceId:
            this.filtersSelected.compliancereasons?.id ?? null,
          socialSecurityNumber:
            this.filtersSelected.ssnosie?.length == 9
              ? this.filtersSelected.ssnosie
              : null,
          studentSieId:
            this.filtersSelected.ssnosie?.length <= 8
              ? this.filtersSelected.ssnosie
              : null,
          regStudentId:
            this.filtersSelected.ssnosie?.length >= 10
              ? this.filtersSelected.ssnosie
              : null,
          completed: this.filtersSelected.compliances?.id
            ? this.filtersSelected.compliances.id == this.compliancesEnum.si
              ? true
              : false
            : null,
          pageIndex: this.page,
          pageSize: this.pageSize,
        };
        const { data } = await _searchScholarshipProgress(payload);
        this.result = data;
      } else if (
        this.handlerFilterSelected == this.handlerFilterEnum.expiration
      ) {
        const payload = {
          academicYearId: this.filtersSelected.academicYear?.id ?? null,
          monthNumber: this.filtersSelected.period?.id ?? null,
          disciplineTypeId: this.filtersSelected.service?.id ?? null,
          regionId: this.filtersSelected.region?.id ?? null,
          reasonComplianceId:
            this.filtersSelected.compliancereasons?.id ?? null,
          socialSecurityNumber:
            this.filtersSelected.ssnosie?.length == 9
              ? this.filtersSelected.ssnosie
              : null,
          studentSieId:
            this.filtersSelected.ssnosie?.length <= 8
              ? this.filtersSelected.ssnosie
              : null,
          regStudentId:
            this.filtersSelected.ssnosie?.length >= 10
              ? this.filtersSelected.ssnosie
              : null,
          expirationDays: this.filtersSelected.expiration?.id ?? -1,
          completed: null,
          pageIndex: this.page,
          pageSize: this.pageSize,
        };
        const { data } = await _searchScholarship(payload);
        this.result = data;
      }
    },
    async onChangeAcademicYear() {
      this.$nextTick(() => {
        const academicYearId = this.filtersSelected.academicYear?.id;
        if (!academicYearId) return;

        this.filtersSelected = {
          ...this.filtersSelected,
          period: null,
          service: null,
        };
        this.callGetPeriods(academicYearId);
      });
    },
    async onSearchHandler() {
      this.allSelected = null;
      this.page = 1;
      this.pageSize = DEFAULT_PAGE_SIZE;
      this.selectedPaging = {
        id: DEFAULT_PAGE_SIZE,
        name: DEFAULT_PAGE_SIZE,
      };
      await this.callSearchScholarship();
    },
    goToPageHandler(page) {
      this.page = page;
      this.callSearchScholarship();
    },
    onChangeCompliances() {
      if (this.filtersSelected.compliances.id == this.compliancesEnum.si) {
        this.hideDropDown = true;
      } else {
        this.hideDropDown = false;
      }
    },
    mutateResult(rowIndex, prop, value) {
      this.result = {
        ...this.result,
        data: this.result.data.map((item, index) => {
          if (index === rowIndex) {
            if (value === this.additionalSectionEnum.TABS) {
              item.mainTabModel = null;
              item.isOpen = !item.isOpen;
              item[prop] = value;
            } else {
              if (value) {
                item[prop] = value;
                item.isOpen = true;
              }
            }
          } else {
            item.mainTabModel = null;
            item.isOpen = false;
          }
          return item;
        }),
      };
    },
    mutateGeneralTabResult(rowIndex, prop, value, tabIndex) {
      this.result = {
        ...this.result,
        data: this.result.data.map((item, index) => {
          if (index === rowIndex) {
            if (value === this.additionalSectionEnum.TABS) {
              item.isOpen = true;
              item.mainTabModel = tabIndex;
              item[prop] = value;
            }
          } else {
            item.mainTabModel = null;
            item.isOpen = false;
          }
          return item;
        }),
      };
    },
    setResultProp(rowIndex, prop, value) {
      this.result = {
        ...this.result,
        data: this.result.data.map((item, index) => {
          if (index === rowIndex) {
            if (prop && value) {
              item[prop] = value;
            }
          }
          return item;
        }),
      };
    },
    async onOpenDetails(rowItem, rowIndex) {
      this.mutateResult(
        rowIndex,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.TABS
      );
    },
    onDocumentPayrollHandler(payroll) {
      const { index } = payroll;
      this.resetModel();
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.DOCUMENT_PAYROLL
      );

      const payrollInfo = payroll.value;
      // if type is any of the facturacion en linea then set its default value
      // and as read only.
      if (
        payrollInfo.payrollReceiveTypeId ===
          payrollReceiveTypes.FacturacionEnLineaSAEE ||
        payrollInfo.payrollReceiveTypeId ===
          payrollReceiveTypes.FacturacionEnLineaRP
      ) {
        this.model.receive = {
          id: payrollInfo.payrollReceiveTypeId,
          name: payrollInfo.payrollReceiveTypeName,
          disabled: true,
        };

        if (
          payrollInfo.payrollDate !== undefined &&
          payrollInfo.payrollDate !== null
        ) {
          this.model.payrollDate = new Date(payrollInfo.payrollDate);
          this.model.payrollDateReadonly = true;
        }

        if (
          payrollInfo.payrollReceivedDate !== undefined &&
          payrollInfo.payrollReceivedDate !== null
        ) {
          this.model.receiveDate = new Date(payrollInfo.payrollReceivedDate);
          this.model.receivedDateReadonly = true;
        } else if (
          [
            payrollReceiveTypes.FacturacionEnLineaSAEE,
            payrollReceiveTypes.FacturacionEnLineaRP,
          ].includes(payrollInfo.payrollReceiveTypeId) &&
          (payrollInfo.payrollReceivedDate === undefined ||
            payrollInfo.payrollReceivedDate === null)
        ) {
          //si es facturación en linea y no tiene fecha de recibo se asigna la misma de nómina
          this.model.receiveDate = new Date(payrollInfo.payrollDate);
          this.model.receivedDateReadonly = true;
        }
      }
    },
    resetModel() {
      this.model = {
        complianceReasons: [],
        selectedComplianceReason: null,
        assistanceDenialDescription: null,
      };
    },
    async onConfirmHandler(index) {
      const isValid = await this.$refs.sectionFormRef[index].validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      //validate dates --------------------------------------------------------
      //extract payrollDate (without time)
      let payrollDate = new Date(
        this.model.payrollDate.getFullYear(),
        this.model.payrollDate.getMonth(),
        this.model.payrollDate.getDate()
      );

      if (payrollDate > this.model.receiveDate) {
        this.ShowToast(
          'Alerta',
          'La fecha de nómina no puede ser mayor a la fecha de recibido',
          'error'
        );
        return false;
      }
      //validate dates end ---------------------------------------------------

      const responseModal = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea continuar documentando la nómina?',
        'Sí',
        'No'
      );
      if (responseModal) {
        const parameters = {
          payrollDate: this.model.payrollDate,
          payrollReceivedDate: this.model.receiveDate,
          payrollReceiveTypeId: this.model.receive.id,
          assistanceDetailCount: parseInt(this.model.assistance),
          becaAssistanceDetailSP: this.result.data[index],
        };
        const isSuccess = await _updateAssistanceSummary(parameters);
        if (isSuccess) {
          this.ShowToast(
            'Alerta',
            'Se ha guardado los datos de la Nómina',
            'success'
          );
          this.resetModel();
          this.closeOpenedSection(index);
          this.callSearchScholarship();
        } else {
          this.ShowToast('Alerta', 'Error al Documentar Nómina', 'error');
          return;
        }
      }
    },
    closeOpenedSection(index) {
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.TABS
      );
    },
    onCancelDocPayrollHandler(index) {
      this.resetModel();
      this.closeOpenedSection(index);
    },
    goToPeiInformation() {
      this.$router.push({
        name: PEI_INFORMATION_ROUTE_NAME,
        params: {
          academicYear: this.filtersSelected.academicYear ?? null,
          ssnosie: this.filtersSelected.ssnosie,
        },
      });
    },
    async onSelectTabAssistanceDetails(
      index,
      {
        assistanceSummaryId,
        payrollReceiveTypeId,
        studentSieId,
        academicYearId,
        monthNumber,
        peiAnalysisServiceId,
      }
    ) {
      if (
        payrollReceiveTypeId == payrollReceiveTypes.FacturacionEnLineaSAEE ||
        payrollReceiveTypeId == payrollReceiveTypes.FacturacionEnLineaRP
      ) {
        const { data: billingResponse } = await _getBillingAssistance(
          studentSieId,
          academicYearId,
          monthNumber,
          peiAnalysisServiceId,
          payrollReceiveTypeId,
          assistanceSummaryId
        );
        this.setResultProp(index, 'assistanceVisitResult', billingResponse);
      }

      const { data: responseNormal } = await _getAssistanceDetailInfo(
        assistanceSummaryId,
        true
      ); // normal assistances
      const { data: responsePeriods } = await _getAssistanceDetailPeriods(
        assistanceSummaryId
      ); //adjustment periods

      //get assistance service
      const { data: assistanceService } = await _getAssistanceDetailService(
        assistanceSummaryId
      );

      this.setResultProp(
        index,
        'adjustPeriods',
        responsePeriods.map((x) => {
          x.monthShortName = x.monthShortName.replace('.', '');
          return x;
        })
      );

      this.setResultProp(index, 'normalAssistances', responseNormal);
      this.setResultProp(index, 'assistanceService', assistanceService);

      if (responsePeriods) {
        const firstPeriod = responsePeriods[0];
        if (firstPeriod) {
          const { data: responseAdjust } = await this.getAdjustmentAssistance(
            assistanceSummaryId,
            firstPeriod.monthNumber,
            firstPeriod.year
          );

          this.setResultProp(index, 'adjustAssistances', responseAdjust);

          //set first as selected
          this.setResultProp(index, 'selectedPeriod', firstPeriod.id);
        }
      }
    },
    async onSelectTabPayment(
      index,
      { assistanceSummaryId, academicYearId, summaryParentId }
    ) {
      if (assistanceSummaryId && academicYearId) {
        var summaryId =
          summaryParentId != null ? summaryParentId : assistanceSummaryId;
        const isParent =
          summaryParentId != null && summaryParentId == assistanceSummaryId;
        const { data: response } = await _getPaymentDetail(
          summaryId,
          academicYearId
        );
        if (response) {
          this.setResultProp(
            index,
            'payment',
            isParent
              ? response
              : {
                  ...response,
                  paymentJournalNumber: response.paymentJournalNumber,
                  paymentDate: response.paymentDate,
                }
          );
        }

        const { data: result } = await _getAdditionalPaymentList(
          assistanceSummaryId
        );
        if (result) {
          this.setResultProp(index, 'additionalPayments', result);
        }

        this.onPaymentRelationshipHandler(assistanceSummaryId);
      }
    },
    async getAdjustmentAssistance(assistanceSummaryId, month, year) {
      return await _getAssistanceDetailInfo(
        assistanceSummaryId,
        false,
        month,
        year
      );
    },
    async onSelectAdjustmentPeriodHandler(
      index,
      { assistanceSummaryId },
      { monthNumber, year }
    ) {
      if (assistanceSummaryId && monthNumber && year) {
        const { data: responseAdjustment } = await this.getAdjustmentAssistance(
          assistanceSummaryId,
          monthNumber,
          year
        );
        this.setResultProp(index, 'adjustAssistances', responseAdjustment);
      }
    },
    async onUpdateMillageCompanion(index, { assistanceSummaryId }) {
      await _updateMillageCompanion(assistanceSummaryId);
      await _getAssistanceDetailService(assistanceSummaryId).then((res) => {
        this.setResultProp(index, 'assistanceService', res.data);
        this.setResultProp(index, 'costTotalAmt', res.data.costTotalAmt);
      });
    },
    async callAdvanceFilters() {
      const { data } = await _getAdvanceFilters();

      this.advanceFilters = {
        regions: data.region,
        assistanceApprovalStatus: data.assistanceApprovalStatus,
        reasons: data.reasons,
        complianceReasons: data.complianceReasons,
        analyzing: [
          { id: 1, name: 'Sí' },
          { id: 2, name: 'No' },
        ],
        workings: [
          { id: 1, name: 'Sí' },
          { id: 2, name: 'No' },
        ],
        compliances: [
          { id: 1, name: 'Sí' },
          { id: 2, name: 'No' },
        ],
        presents: [
          { id: null, name: 'Todos' },
          { id: 1, name: 'Elegibles' },
          { id: 2, name: 'No Elegibles' },
        ],
        receiveTypes: data.receiveTypes,
        schools: [],
        expirations: [
          { id: 0, name: '40 días o menos en vencimiento' },
          { id: 1, name: '41-59 días en vencimiento' },
          { id: 2, name: 'Vencidas' },
        ],
      };

      this.filtersSelected = {
        ...this.filtersSelected,
        present: this.advanceFilters.presents[1],
      };
    },
    async callGetAdjustmentReasons() {
      const { data } = await _getAdjustmentReasons();
      this.model = {
        ...this.model,
        adjustmentReasons: data,
      };
    },
    async callGetFollowUpCategories() {
      const { data } = await _getFollowUpCategories();
      this.model = {
        ...this.model,
        followUpCategories: data,
      };
    },
    async onSelectTabProgressReport(index, { assistanceSummaryId }) {
      if (assistanceSummaryId) {
        const { data: responseProgress } = await _getProgressReport(
          assistanceSummaryId
        );
        if (responseProgress) {
          this.setResultProp(index, 'progressReport', responseProgress);
        }
      }
    },
    onSelectHistoryTab(index) {
      this.setResultProp(index, 'showHistory', true);
    },
    async onApproveAssistanceHandler() {
      this.result.data.forEach((item) => {
        if (item.isChecked && this.getStatus(item.assistanceApprovalStatusCd)) {
          if (
            item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
            !item.isManualAssistanceFlag &&
            item.analyzedById == null
          ) {
            this.allSelected = false;
            this.assistanceSummariesToApprove = [];
          }

          this.assistanceSummariesToApprove.push(item);
        }
      });

      if (this.assistanceSummariesToApprove.length > 0) {
        //verify if contains some invalid approve payment
        const hasSomeInvalidApprovePayment = this.assistanceSummariesToApprove.some(
          (item) =>
            item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
            !item.isManualAssistanceFlag &&
            item.analyzedById == null
        );

        if (hasSomeInvalidApprovePayment) {
          this.ShowToast(
            '',
            'Los records Educativo Públicos deben estar marcados analizados para poder aprobar los pagos.',
            'error'
          );
          this.setInvalidApprovePayment();
          this.cleanSelectedToApprove();
          return;
        } else {
          this.setInvalidApprovePayment();
        }

        //verify if contains some invalid totalAmount
        const hasSomeInvalid = this.assistanceSummariesToApprove.some(
          (s) => !s.costTotalAmt
        );
        if (hasSomeInvalid) {
          this.ShowToast(
            '',
            'El record de pago no cuenta con un total valido para ser aprobado.',
            'error'
          );
          this.setInvalidTotalAmount();
          this.cleanSelectedToApprove();
          return;
        } else {
          this.setInvalidTotalAmount(); //reset original values
        }

        //verify if contains any not eligible student
        const hasNotEligibleStudent = this.assistanceSummariesToApprove.some(
          (s) => s.isNotEligible
        );

        if (hasNotEligibleStudent) {
          this.ShowToast(
            '',
            'No es posible aprobar la(s) asitencia(s), ya que cuenta con estudiante(s) no elegible(s) para Becas \
            de Transportación de acuerdo a los PEI’s firmados en el sistema.',
            'error'
          );
          this.setNotEligibleStudent();
          this.cleanSelectedToApprove();
          return;
        } else {
          this.setNotEligibleStudent(); //reset original values
        }

        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea marcar como Aprobado(s) el(los) record(s) seleccionado(s)?',
          'Sí',
          'No'
        );

        if (answer) {
          this.allSelected = false;
          const summaries = this.assistanceSummariesToApprove.map((x) => ({
            assistanceSummaryId: x.assistanceSummaryId,
          }));
          await _approveAttendance(summaries)
            .then(() => {
              this.callSearchScholarship();
              this.ShowToast(
                '',
                'El(los) record(s) fueron Aprobados exitosamente.',
                'success'
              );
              this.cleanCheckData();
            })
            .catch((error) => {
              this.cleanCheckData();
              this.ShowToast('', error, 'error');
            });
        }
      }
    },
    onDenegateAssistanceHandler(index, item) {
      if (
        item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
        item.isManualAssistanceFlag == false &&
        item.analyzedById == null
      ) {
        this.ShowToast(
          '',
          'Los records Educativo Públicos deben estar marcados Analizados para poder denegar los pagos.',
          'error'
        );
        return;
      }

      this.callDetailsDropdown();
      this.callGetAssistanceSummariesForDenyPayments(item);
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.DENEGATE_ASSISTANCE
      );
    },
    onCancelDenegateHandler(index) {
      this.closeOpenedSection(index);
    },
    onAdditionalPayment(index) {
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.ADDITIONAL_PAYMENT
      );
    },
    onCancelAdditionalPayment(index) {
      this.closeOpenedSection(index);
    },
    async onConfirmAdditionalPayment(index, model) {
      const isValid = await this.$refs.sectionFormRef[index].validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea documentar el <b>Pago Adicional</b> al record seleccionado?  ',
        'Sí',
        'No'
      );
      if (answer) {
        const user = await getUser();
        let parameters = {
          AssistanceSummaryId: this.result.data[index].assistanceSummaryId,
          TotalAttendedAmt: model.amount,
          AdditionalPaymentComment: model.comment,
          CreatedById: user.profile.sub,
        };
        await _additionalPayment(parameters);
        this.callSearchScholarship();
      }
    },
    onManualAdjustment(index, item) {
      if (
        item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
        !item.isManualAssistanceFlag &&
        item.analyzedById == null
      ) {
        this.ShowToast(
          '',
          ' Los record Educativo Públicos deben estar marcados Analizados para poder realizarle un Ajuste Manual.',
          'error'
        );
        return;
      }
      if (
        item.peiAnalysisServiceId == serviceTypeEnum.educativo &&
        item.isManualAssistanceFlag &&
        item.payrollDate == null
      ) {
        this.ShowToast(
          '',
          'El record de pago no contiene una nómina documentada. ',
          'error'
        );
        return;
      }
      this.callGetAdjustmentReasons();
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.MANUAL_ADJUSTMENT
      );
    },
    onCancelManualAdjustment(index) {
      this.closeOpenedSection(index);
    },
    async onSaveManualAdjustment(index, model) {
      let answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea realizar el Ajuste Manual al  pago seleccionado?  ',
        'Sí',
        'No'
      );

      if (answer) {
        await _manualAdjustmentAssistance(model)
          .then(() => {
            this.closeOpenedSection(index);
            this.callSearchScholarship();
            this.ShowToast(
              'Proceso exitoso',
              'El ajuste manual fue realizado exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      }
    },
    async onDeleteManualAdjustment(index, assistanceSummaryId) {
      let answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea remover el Ajuste Manual al pago seleccionado?  ',
        'Sí',
        'No'
      );

      if (answer) {
        await _removeManualAdjustment(assistanceSummaryId)
          .then(() => {
            this.closeOpenedSection(index);
            this.callSearchScholarship();
            this.ShowToast(
              '',
              'El ajuste manual fue removido exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('', error, 'error');
          });
      }
    },
    async onFollowUpAssitance(index, item) {
      await this.callGetFollowUpCategories();
      await this.callGetAssistanceSummaries(item);
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.FOLLOW_UP
      );
    },
    onCancelFollowUp(index) {
      this.closeOpenedSection(index);
    },
    async onSaveFollowUp(index, item) {
      const payload = {
        assistanceSummaryIds: item.assistanceSummaryIds,
        followUpCategoryId: item.optionId,
        followUpComment: item.comment,
      };

      let answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea guardar el Comentario documentado?',
        'Sí',
        'No'
      );

      if (answer) {
        await _saveFollowUpAssistance(payload)
          .then(() => {
            this.closeOpenedSection(index);
            this.callSearchScholarship();
            this.ShowToast(
              '',
              'El comentario fue guardado exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('', error, 'error');
          });
      }
    },
    onPaymentRelationship(index) {
      if (
        this.result.data[index].peiAnalysisServiceId ==
          serviceTypeEnum.educativo &&
        !this.result.data[index].isManualAssistanceFlag &&
        this.result.data[index].analyzedById == null
      ) {
        this.ShowToast(
          '',
          'Los records Educativos Públicos deben estar marcados Analizados para poder completar la acción de Relación de Pagos.',
          'error'
        );
        return;
      }

      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.PAYMENT_RELATIONSHIP
      );
    },
    async InitPayrollFilter() {
      const { data } = await _getPayrollReceiveTypeAsync();
      this.filterPayRoll = data;
    },
    cleanCheckData() {
      this.allSelected = false;
      this.assistanceSummariesToApprove = [];
      this.model = {};
    },
    async onSaveDenegateHandler(index, item) {
      const user = await getUser();

      if (
        this.result.data[index].peiAnalysisServiceId ==
          serviceTypeEnum.educativo &&
        !this.result.data[index].isManualAssistanceFlag &&
        this.result.data[index].analyzedById == null
      ) {
        this.ShowToast(
          '',
          'Los records Educativo Públicos deben estar marcados Analizados para poder denegar los pagos.',
          'error'
        );
        this.closeOpenedSection(index);
        this.cleanCheckData();
        return;
      }

      const payload = {
        assistanceSummaryIds: item.assistanceSummaryIds,
        assistanceDenialReasonCd: item.optionId,
        assistanceDenialDescription: item.comment,
        assistanceDenialById: user.profile.sub,
      };

      if (payload != null) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea denegar el pago seleccionado?',
          'Sí',
          'No'
        );

        if (answer) {
          this.allSelected = false;
          await _denyassistance(payload)
            .then(() => {
              this.ShowToast(
                '',
                'El record de pago fue Denegado exitosamente.',
                'success'
              );
              this.closeOpenedSection(index);
              this.cleanCheckData();
              this.callSearchScholarship();
            })
            .catch((error) => {
              this.closeOpenedSection(index);
              this.cleanCheckData();
              this.ShowToast('', error, 'error');
            });
        }
      }
    },
    async callDetailsDropdown() {
      const { data } = await _compliancereasons();
      this.model = {
        ...this.model,
        complianceReasons: data,
      };
    },
    async onActiveTab(item, index) {
      if (
        index == 0 &&
        item.studentSieId &&
        this.isTherapyService(item.peiAnalysisServiceId)
      ) {
        //additional info tab
        const { data: response } = await _getAssistanceTherapyInfo(
          item.academicYearId,
          item.studentSieId,
          item.peiAnalysisServiceId
        );
        this.thrpyInfo = response;
      }
      //transportation section
      const { data: transportation } = await _getAssistanceTransportationInfo(
        item.academicYearId,
        item.studentSieId,
        item.peiAnalysisServiceId
      );
      this.transportationInfo = transportation;
    },
    onCancelPaymentRelatinship(index) {
      this.closeOpenedSection(index);
    },
    onRefreshPaymentRelationshipHandler() {
      this.callSearchScholarship();
    },
    async callGetAssistanceSummaries(item) {
      const { data } = await _getAssistanceSummaries(
        item.academicYearId,
        item.studentSieId,
        item.assistanceSummaryId
      );
      this.model = {
        ...this.model,
        assistanceSummariesRelated: data,
      };
    },
    async callGetAssistanceSummariesForDenyPayments(item) {
      const { data } = await _getAssistanceSummariesForDenyPayments(
        item.academicYearId,
        item.studentSieId,
        item.assistanceSummaryId
      );
      this.model = {
        ...this.model,
        assistanceSummariesRelated: data,
      };
    },
    async restartStatusHandler({ assistanceSummaryId }) {
      if (assistanceSummaryId) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea reiniciar el estatus del pago?',
          'Sí',
          'No'
        );
        if (answer) {
          const { data: validationResponse } = await _checkPaymentStatus(
            assistanceSummaryId
          );
          if (validationResponse.isValid) {
            const answerValidation = await this.ShowCancelModal(
              'Atención',
              validationResponse.validationMessage,
              'Sí',
              'No'
            );
            if (answerValidation) {
              const {
                data: deleteResponse,
              } = await _deleteRecordFromPaymentJournal(assistanceSummaryId);
              if (deleteResponse.isValid) {
                this.ShowToast(
                  '',
                  'El Estatus ha sido reiniciado exitosamente.',
                  'success'
                );
                this.callSearchScholarship();
              }
            } else {
              return;
            }
          }
          const { data: resetResponse } = await _resetPaymentStatus(
            assistanceSummaryId
          );
          if (resetResponse.isValid) {
            this.ShowToast(
              '',
              'El Estatus ha sido reiniciado exitosamente.',
              'success'
            );
            this.callSearchScholarship();
          } else {
            this.ShowToast('', resetResponse.validationMessage, 'error');
          }
        }
      }
    },
    async onCertificationDocumentHandler(index) {
      if (this.result.data[index].assistanceSummaryId) {
        await _getCertificationDocument(
          this.result.data[index].assistanceSummaryId
        )
          .then((response) => {
            _generalApi.ConvertToBlob(response.data);
          })
          .catch((response) => {
            this.ShowToast(
              '',
              response.data?.message ||
                'Ha ocurrido un error al descargar el documento.',
              'error'
            );
          });
      }
    },
    async onPaymentRelationshipHandler(assistanceSummaryId) {
      this.relationshipPayment = {};
      const { data } = await _getPaymentRelationship(assistanceSummaryId);
      this.relationshipPayment = data;
    },
    setInvalidTotalAmount() {
      this.result = {
        data: this.result.data.map((x) => {
          if (x.isChecked && !x.costTotalAmt) {
            x.invalidTotalAmount = true;
          } else {
            x.invalidTotalAmount = false;
          }
          return x;
        }),
      };
    },
    setInvalidApprovePayment() {
      this.result = {
        data: this.result.data.map((x) => {
          if (
            x.isChecked &&
            x.peiAnalysisServiceId == serviceTypeEnum.educativo &&
            !x.isManualAssistanceFlag &&
            x.analyzedById == null
          ) {
            x.invalidApprovePayment = true;
          } else {
            x.invalidApprovePayment = false;
          }
          return x;
        }),
      };
    },
    async onDeleteAdditionalPaymentHandler(assistanceSummaryId) {
      if (assistanceSummaryId) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea eliminar el pago adicional documentado para el record?',
          'Sí',
          'No'
        );
        if (answer) {
          const { data } = await _deleteAdditionalPayment(assistanceSummaryId);
          if (data) {
            this.ShowToast(
              '',
              'El pago adicional ha sido eliminado exitosamente.',
              'success'
            );
            this.callSearchScholarship();
          }
        }
      }
    },
    async onDeleteRelationHandler(parentSummary, { assistanceSummaryId }) {
      if (assistanceSummaryId) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea eliminar la relación de pago documentada para el record?',
          'Sí',
          'No'
        );
        if (answer) {
          const isParent =
            parentSummary.summaryParentId != null &&
            parentSummary.summaryParentId != parentSummary.assistanceSummaryId;
          const { data } = await _removeServiceRelation(
            parentSummary.assistanceSummaryId,
            assistanceSummaryId,
            isParent
          );
          if (data) {
            this.ShowToast(
              '',
              'La relación de pago ha sido eliminada exitosamente.',
              'success'
            );
            this.callSearchScholarship();
          }
        }
      }
    },
    async onSetFindingCommentHandler(index) {
      this.mutateResult(
        index,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.FINDING_COMMENT
      );
    },
    async onCancelFindingCommentHandler(index, item) {
      this.closeOpenedSection(index);
      item.openedFindingComment = null;
      await this.$forceUpdate();
    },
    async onSaveFindingCommentHandler(index, item, comment) {
      if ((item, comment)) {
        const payload = {
          eligibleStudentId: item.eligibleStudentId,
          comment,
        };

        let answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea guardar el Comentario documentado?',
          'Sí',
          'No'
        );

        if (answer) {
          const { data } = await _saveFindingComment(payload);
          if (data) {
            this.closeOpenedSection(index);
            this.callSearchScholarship();
            this.ShowToast(
              '',
              'El comentario fue guardado exitosamente.',
              'success'
            );
          }
        }
      }
    },
    async restartPayrollHandler({ assistanceSummaryId }) {
      if (assistanceSummaryId) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea reiniciar la documentación de la nómina?',
          'Sí',
          'No'
        );
        if (answer) {
          const { data } = await _resetPayroll(assistanceSummaryId).catch(
            ({ response: err }) => {
              this.ShowToast('', err.data.message || 'error', 'error');
            }
          );

          if (data) {
            this.ShowToast(
              '',
              'La documentación de la nómina ha sido reiniciada exitosamente.',
              'success'
            );
            this.callSearchScholarship();
          }
        }
      }
    },
    async onSelectTabIndexHandler(rowIndex, item, tabIndex) {
      this.mutateGeneralTabResult(
        rowIndex,
        OPENED_SECTION_KEY,
        this.additionalSectionEnum.TABS,
        tabIndex
      );

      if (tabIndex == 1) {
        await this.onSelectTabAssistanceDetails(rowIndex, item);
      }
      if (tabIndex == 2) {
        await this.onSelectTabPayment(rowIndex, item);
      }
      if (tabIndex == 3) {
        await this.onSelectHistoryTab(rowIndex, item);
      }

      item.mainTabModel = tabIndex;
      await this.$forceUpdate();
    },
    async onSelectedPagingHandler(value) {
      if (value?.id) {
        this.pageSize = value?.id;
        await this.callSearchScholarship();
      }
    },
    setNotEligibleStudent() {
      this.result = {
        data: this.assistanceSummariesToApprove.map((x) => {
          if (x.isChecked && x.isNotEligible) {
            x.notEligibleStudent = true;
          } else {
            x.notEligibleStudent = false;
          }
          return x;
        }),
      };
    },
    cleanSelectedToApprove() {
      this.assistanceSummariesToApprove = [];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.dropdown-solid {
  background-color: map-get($colors, 'secondary-22');
  border: 1px solid map-get($colors, 'secondary-22');
  color: #fff;
  font-weight: 400;
  width: auto;
  height: 38px;
}
.dropdown-solid i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.dropdown-solid::after {
  border: none;
}

.denegate-container {
  .reason-field {
    max-width: 300px;
  }
}

.no-eligible-message {
  font-family: Lato !important;
}

::v-deep .custom-tab-container {
  margin-bottom: 30px !important;
}

::v-deep .custom-date-picker {
  .width-container {
    width: unset !important;
  }
}

::v-deep .callout__extended {
  .col.p-2.ml-2 {
    padding: unset !important;
  }
}

@media only screen and (max-width: 768px) {
  .doc-payroll-action {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px !important;
    margin-left: 10px;
    margin-right: 60px;
    button {
      display: flex;
      align-items: center;
      padding: 10px !important;
    }
  }

  .scholarship-attendence {
    &__action-button {
      font-size: 14px;
      padding: 5px;
      padding-right: 10px;
    }

    &__page-header ::v-deep {
      .tag-badge-title {
        font-size: 18px;
      }

      .controls-wrap {
        .nav-text,
        .nav-text-link {
          color: map_get($colors, 'gray-6');
          font-size: 12px;
        }

        .nav-text {
          font-weight: normal;
        }

        .nav-text-link {
          font-weight: 400;
        }
      }

      .actions {
        display: flex !important;
      }
    }

    &__filter-manager ::v-deep {
      .custom-ddl {
        font-size: 14px;

        .vs__selected {
          font-weight: bold;
        }
      }

      // @todo put a selector more scalable
      & > span > .row > .col-sm > .d-flex.justify-content-md-end {
        justify-content: flex-end !important;
        padding-right: 15px;
        margin-top: 15px;
      }
    }
  }
}
</style>
